import { Account } from "models/Account";
import { LOGOUT_USER_ACCOUNT } from "store/actions/Auth";
import { createReducer } from "./Util";
import { ADD_CUSTOMER, EDIT_CUSTOMER, GET_AUTH_CUSTOMER, GET_CUSTOMER, GET_CUSTOMERS } from "store/actions/Customers";

export class CustomerState {

  private customers: { [index: string]: Account }

  constructor() {
    this.customers = {}
  }

  public setCustomers(customers: Account[]) {
    this.customers = {}
    customers.forEach(customer => {
      this.setCustomer(customer)
    })
    return this
  }

  public isFetched(): boolean {
    return Object.values(this.customers).length > 0;
  }

  public setCustomer(customer: Account) {
    this.customers[customer.id] = customer
    return this
  }

  public getCustomerById(id: string): Account | null {
    return this.customers[id] ?? null
  }

  public findByEmail(email: string): Account[] {
    let found: { [index: string]: Account } = {}
    Object.values(this.customers).forEach(customer => {
      if (customer.email === email) {
        found[customer.id] = customer;

      }
    })
    return Object.values(found);
  }

  public getCustomers(): Account[] {
    return Object.values(this.customers)
  }

  public getCustomersByTenantId(tenantId: string): Account[] {
    return Object.values(this.customers).filter(x => x.tenant === tenantId)
  }

  public getCustomersByIds(ids: string[]): Account[] {
    return Object.values(this.customers).filter(function (el) {
      return ids.indexOf(el.id) >= 0;
    });
  }

}

const Customers = createReducer<CustomerState>(new CustomerState())
  .handle<Account[]>([GET_CUSTOMERS.SUCCESS], (state, payload) => state.setCustomers(payload))
  .handle<Account[]>([GET_AUTH_CUSTOMER.SUCCESS], (state, payload) => state.setCustomers(payload))
  .handle<Account>([GET_CUSTOMER.SUCCESS], (state, payload) => state.setCustomer(payload))
  .handle<Account>([EDIT_CUSTOMER.SUCCESS], (state, payload) => state.setCustomer(payload))
  .handle<Account>([ADD_CUSTOMER.SUCCESS], (state, payload) => state.setCustomer(payload))
  .handle([LOGOUT_USER_ACCOUNT.SUCCESS], () => new CustomerState());

export default Customers.handler;
